export const useMobileExpansion = () => {
    const initMobileExpansions = () => {
        const expansions = document.querySelectorAll(
            ".js-ns-mobile-expansion-item"
        );

        expansions.forEach(($el) => {
            const $slider = $el.closest(".js-ns-mobile-navigation-slider");
            const $column = $el.closest(".js-ns-mobile-navigation-column");
            const $button = $el.querySelector(".js-ns-mobile-expansion-button");
            const $content = $el.querySelector(
                ".js-ns-mobile-expansion-content"
            );
            const $inner = $el.querySelector(".js-ns-mobile-expansion-inner");

            let isOpened = false;
            let isTransition = false;

            $button.addEventListener("click", () => {
                if (isTransition === true) {
                    return;
                }

                isTransition = true;

                const columnHeight = $column.clientHeight;
                const innerHeight = $inner.clientHeight;

                $el.classList.toggle("active");

                if (isOpened === false) {
                    $button.setAttribute("aria-expanded", "true");

                    $content.style.height = `${innerHeight}px`;
                    $content.removeAttribute("inert");

                    $slider.style.height = `${columnHeight + innerHeight}px`;
                } else {
                    $button.setAttribute("aria-expanded", "false");

                    $content.style.height = 0;
                    $content.setAttribute("inert", true);

                    $slider.style.height = `${columnHeight - innerHeight}px`;
                }

                isOpened = !isOpened;

                setTimeout(() => {
                    isTransition = false;
                }, 300);
            });
        });
    };

    return {
        initMobileExpansions,
    };
};
